export const adaptVessel = data => ({
  identifier: `${data.Company}:${data.VesselID}`,
  VesselID: `${data.VesselID}`,
  VesselName: `${data.VesselName}`,
  Company: `${data.Company}`,
  PrefCompany: data.PrefCompany
});